import { Input } from '@/components/ui'
import SectionForm, { getFormField, useFormContext } from "../SectionForm"
import { useBienContext } from '../BienContext'

const FieldList = [
  // Partie 1
  {name: "monopropriete_nombre_de_lots", label: "Nombre de lots", type: "text"},
  // Partie 2
  {name: "monopropriete_details_lots", label: "Détail des lots", type: "textarea",
    hint: "(loyers + charges + DPE)"
  },
  // Partie 3
  {name: "monopropriete_info_locataires", label: "Info Locataires", type: "textarea",
    hint: "(Impayés ? GLI ? Entente ? Procédure ?)"
  },
  // Partie 4
  {name: "monopropriete_entretien_espaces_verts", label: "Entretien espaces verts réguliers", type: "toggle" },
  {name: "monopropriete_entretien_communs", label: "Entretien espaces verts communs", type: "toggle" },
]

// typeBien est passé en props car SectionForm
// ne crée les values dans le form que pour les fields définis
const FormContent = ({item}) => {
  const { control } = useFormContext()
  return (
    <>
      <div className="flex flex-col items-center gap-4 mt-4">                
        {getFormField(control, FieldList[0], 0) }
      </div>
      <div className="flex flex-col items-center gap-4">                
        {getFormField(control, FieldList[1], 1) }
        {getFormField(control, FieldList[2], 2) }
      </div>
      <div className="flex flex-col items-center gap-4 mt-4">                
        {getFormField(control, FieldList[3], 3) }
        {getFormField(control, FieldList[4], 4) }
        <Input.File control={control}
          name="reglement_commun_file"
          label="Règlement commun"
          defaultValue={item.reglement_commun_file?.filename || '' }
          inputProps={{accept: ".pdf"}}
          canDelete={true}
        />
      </div>
    </>
  )
}

const Form = ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  const { bien } = useBienContext()

  return (
    <SectionForm
      title={title}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={[...FieldList.map( f => f.name), "reglement_commun_file"]}
    >
      <FormContent item={bien} />
    </SectionForm>
  )
}

export default Form